// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1qNmY","card":"style_card__2aqjh","cardBody":"style_cardBody__1a70l","btn":"style_btn__110BU"};